// English placeholder until translated.
export const MARKETS_AM = {
    match_odds_ft: "Match odds (full time)",
    match_odds_ht: "Match odds (half time)",
    goals_ft: "Over/Under {{line}} goals (full time)",
    goals_ht: "Over/Under {{line}} goals (half time)",
    player_scores: "{{player}} scores (full time)",
    corners_ft: "Corners over/under {{line}} (full time)",
    cards_ft: "Cards over/under {{line}} (full time)",
    draw: "Draw",
    over: "Over {{line}}",
    under: "Under {{line}}",
    yes: "Yes",
    no: "No",
}
